import { DefaultPageHeader } from 'layouts';
import type { UserBase } from 'models';
import { useGetMemberEntityBreadcrumb } from '../hooks';

type P = {
  member: UserBase;
};

const MemberOrganizationsHeader = ({ member }: P) => {
  const breadcrumbRoutes = useGetMemberEntityBreadcrumb({ entityScope: 'organizations', member });

  return <DefaultPageHeader routes={breadcrumbRoutes} title="Joined organizations" />;
};

export default MemberOrganizationsHeader;
